_getUserPortalSubscribers